import { System } from '@x/types';
import { ApiQueryConfig } from 'api/types';
import { URLS } from 'config';
import { createApiEndpoint } from '../utils';

type SystemPathParams = { $systemId: number };
type GetSystemConfig = ApiQueryConfig<
  System,
  SystemPathParams,
  unknown,
  unknown
>;

export const getSystem = createApiEndpoint<GetSystemConfig>({
  method: 'GET',
  url: `${URLS.app}/api/Systems/$systemId`,
  transformResponse: (data: string) => {
    const json = JSON.parse(data);

    return {
      ...json,
      SettingsSchema: JSON.parse(json.SettingsSchema),
      Settings: JSON.parse(json.Settings),
    };
  },
});
